<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export interface ChipOption {
    value: string;
    label: string;
    hint?: string;
    disabled?: boolean;
  }

  export let options: ChipOption[] = [];
  export let value: string;
  export let ariaLabel = 'Toggle options';

  const dispatch = createEventDispatcher<{ change: { value: string } }>();

  function select(option: ChipOption) {
    if (option.disabled) return;
    value = option.value;
    dispatch('change', { value });
  }
</script>

<div class="chip-group" role="radiogroup" aria-label={ariaLabel}>
  {#each options as option (option.value)}
    <button
      type="button"
      role="radio"
      aria-checked={option.value === value}
      class:selected={option.value === value}
      class:disabled={option.disabled}
      on:click={() => select(option)}
      disabled={option.disabled}
    >
      <span>{option.label}</span>
      {#if option.hint}
        <span class="chip-hint">{option.hint}</span>
      {/if}
    </button>
  {/each}
</div>

<style>
  .chip-group {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.4rem 0.9rem;
    border-radius: var(--radius-lg);
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.06);
    color: var(--color-text-muted);
    font-size: 0.85rem;
    letter-spacing: 0.01em;
    cursor: pointer;
    transition: background 120ms ease, color 120ms ease, box-shadow 120ms ease;
  }

  button:hover:not(.disabled) {
    background: rgba(255, 255, 255, 0.1);
    color: var(--color-text-primary);
  }

  button.selected {
    border-color: rgba(240, 169, 74, 0.55);
    background: linear-gradient(135deg, rgba(240, 169, 74, 0.28), rgba(178, 127, 244, 0.22));
    color: var(--color-text-primary);
    box-shadow: 0 0 0 1px rgba(240, 169, 74, 0.4);
  }

  button.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .chip-hint {
    font-size: 0.7rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.6);
  }
</style>
